class Layout1Controller {
  constructor() {}

  $onInit() {}

  $onChanges(changes) {
    if (changes.template) {
      this.template.elements.forEach(el => (el.value = el.disabledWhenOff && this.template.off ? null : el.value));
    }
  }
}

export default {
  template: require('./layout.html'),
  controller: Layout1Controller,
  bindings: {
    template: '<'
  },
  controllerAs: 'vm'
};
